export default __webpack_public_path__ + "455e782fdbf2082a97cc0973687194ab.png";